export const state = () => ({
  show:
    (JSON.parse(localStorage.getItem('term'))?.mandatory &&
      !JSON.parse(localStorage.getItem('term'))?.accepted) ||
    false,
  currentType: JSON.parse(localStorage.getItem('term'))?.termType || null,
  term: JSON.parse(localStorage.getItem('term')) || null
});

export const mutations = {
  open(state, type) {
    state.show = true;
    state.currentType = type;
  },
  close(state) {
    state.show = false;
    state.currentType = null;
    localStorage.removeItem('term');
  },
  setTerm(state, term) {
    state.term = term;
    localStorage.setItem('term', JSON.stringify(term));
  }
};

export const actions = {
  async checkTerms({ commit, rootState }) {
    const { token } = rootState.user.session;
    const privacy = await this.$api.terms.list(token, 'PRIVACY_POLICY');

    if (privacy.mandatory && !privacy.accepted) {
      commit('setTerm', privacy);
      commit('open', 'PRIVACY_POLICY');
      return true;
    }

    const terms = await this.$api.terms.list(token, 'TERMS_OF_USE');

    if (terms.mandatory && !terms.accepted) {
      commit('open', 'TERMS_OF_USE');
      commit('setTerm', terms);
      return true;
    }
    return false;
  },
  async openTerms({ commit, rootState }, type) {
    const { token } = rootState.user.session;
    const terms = await this.$api.terms.list(token, type);
    commit('setTerm', terms);
    commit('open', type);
  },
  async acceptTerm({ state, commit, dispatch, rootState }) {
    const { token } = rootState.user.session;
    const termType = state.currentType;
    await this.$api.terms.accept(token, termType);
    commit('close');
    if (termType === 'PRIVACY_POLICY') {
      const stillNeeds = await dispatch('checkTerms');
      if (stillNeeds) {
        return;
      }
    }
    localStorage.removeItem('term');
    this.$router.replace('/home');
  },
  closeTerms({ commit }) {
    commit('close');
  }
};
